import * as React from "react";
// import // styled,
// // IconButton,
// // Tooltip,
// // TextField,
// "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TableCell from "@mui/material/TableCell"; // { tableCellClasses }
// import {
//     DeleteOutlineOutlined,
//     EditOutlined,
//     RemoveRedEyeOutlined,
// } from "@mui/icons-material";
export default function FaqTable() {
  return (
    <TableContainer>
      <Table aria-label='customized table'>
        <TableHead>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
          <TableRow>
            <TableCell></TableCell>

            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component='th' scope='row' colSpan={2}>
              No data found
            </TableCell>
          </TableRow>
          {/* {rows.map((row) => (
            <TableRow key={row.name}>
              <TableCell component='th' scope='row'>
                {row.name}
              </TableCell>
              <TableCell >
                <Tooltip title='Edit'>
                  <IconButton aria-label='edit' sx={{ "&:hover":{
                     color: "#293462"
                  } }}>
                    <EditOutlined />
                  </IconButton>
                </Tooltip>
                <Tooltip title='View'>
                  <IconButton aria-label='view' sx={{ "&:hover":{
                     color: "#293462"
                  } }}>
                    <RemoveRedEyeOutlined />
                  </IconButton>
                </Tooltip>
                <Tooltip title='Delete'>
                  <IconButton  aria-label='delete' sx={{ "&:hover":{
                   color: "#F24C4C"
                  } }}>
                    <DeleteOutlineOutlined />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))} */}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
